// import React from "react";
// import { Link } from "react-router-dom";
// import { FiPackage, FiGrid, FiFileText, FiMapPin, FiArrowRight } from "react-icons/fi";
// import "./Dashboard.css";

// const Dashboard = () => {
//   const navigationCards = [
//     {
//       id: 1,
//       title: "Add Product",
//       description: "Create and manage your product inventory",
//       icon: FiPackage,
//       route: "/products",
//       colorClass: "card-product"
//     },
//     {
//       id: 2,
//       title: "Create Category",
//       description: "Organize products into categories",
//       icon: FiGrid,
//       route: "/categories",
//       colorClass: "card-category"
//     },
//     {
//       id: 3,
//       title: "Create Order",
//       description: "Process and manage customer orders",
//       icon: FiFileText,
//       route: "/orders",
//       colorClass: "card-order"
//     },
//     {
//       id: 4,
//       title: "Create Panchayat",
//       description: "Add and manage panchayat information",
//       icon: FiMapPin,
//       route: "/customers",
//       colorClass: "card-panchayat"
//     }
//   ];

//   return (
//     <div className="home-dashboard">
//       {/* Header */}
//       <div className="dashboard-header">
//         <h1 className="dashboard-title">Home Dashboard</h1>
//         <p className="dashboard-subtitle">
//           Manage your products, categories, orders, and panchayats
//         </p>
//       </div>

//       {/* Navigation Cards Grid */}
//       <div className="cards-grid">
//         {navigationCards.map((card, index) => {
//           const IconComponent = card.icon;
//           return (
//             <Link
//               to={card.route}
//               key={card.id}
//               className={`nav-card ${card.colorClass}`}
//               style={{ animationDelay: `${0.1 * (index + 1)}s` }}
//             >
//               <div className="card-arrow">
//                 <FiArrowRight />
//               </div>
//               <div className="card-icon-wrapper">
//                 <IconComponent />
//               </div>
//               <h3 className="card-title">{card.title}</h3>
//               <p className="card-description">{card.description}</p>
//             </Link>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// export default Dashboard;

import React from "react";
import { Link } from "react-router-dom";
import { FiPackage, FiGrid, FiFileText, FiMapPin, FiArrowRight } from "react-icons/fi";
import "./Dashboard.css";

const Dashboard = () => {
  const navigationCards = [
    {
      id: 1,
      title: "Add Product",
      description: "Create and manage your product inventory",
      icon: FiPackage,
      route: "/products",
      colorClass: "card-product"
    },
    {
      id: 2,
      title: "Create Category",
      description: "Organize products into categories",
      icon: FiGrid,
      route: "/categories",
      colorClass: "card-category"
    },
    {
      id: 3,
      title: "Create Order",
      description: "Process and manage customer orders",
      icon: FiFileText,
      route: "/orders",
      colorClass: "card-order"
    },
    {
      id: 4,
      title: "Create Panchayat",
      description: "Add and manage panchayat information",
      icon: FiMapPin,
      route: "/customers",
      colorClass: "card-panchayat"
    }
  ];

  return (
    <div className="home-dashboard">
      {/* Header */}
      <div className="dashboard-header">
        <h1 className="dashboard-title">Home Dashboard</h1>
        <p className="dashboard-subtitle">
          Manage your products, categories, orders, and panchayats
        </p>
      </div>

      {/* Navigation Cards - Single Row */}
      <div className="cards-row">
        {navigationCards.map((card, index) => {
          const IconComponent = card.icon;
          return (
            <Link
              to={card.route}
              key={card.id}
              className={`nav-card ${card.colorClass}`}
              style={{ animationDelay: `${0.1 * (index + 1)}s` }}
            >
              <div className="card-arrow">
                <FiArrowRight />
              </div>
              <div className="card-icon-wrapper">
                <IconComponent />
              </div>
              <h3 className="card-title">{card.title}</h3>
              <p className="card-description">{card.description}</p>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default Dashboard;